import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { taskRateSheets } from "~/routes";
import TaskRateSheetForm from "~/visuals/organisms/TaskRateSheetForm";
import { ErrorRenderer, MutationForm } from "~/components/forms/MutationForm";
import { useRateSheetsContext } from "~/visuals/organisms/RateSheets/rateSheetsContext";

type FormData = {
  name: string | null;
};

const CloneTaskRateSheet: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams<{ name?: string }>();
  const oldSheetName = params?.name ?? "";

  const { reload, clone, mutationLoading } = useRateSheetsContext();

  const onSuccess = () => {
    navigate(taskRateSheets.path);
  };

  const cloneTaskRateSheet = async (values: FormData) => {
    const result = await clone(values.name!, oldSheetName);

    reload();

    return result?.data?.taskRates?.cloneTaskRateSheet;
  };

  return (
    <MutationForm
      initialValues={{ name: null }}
      onSuccess={onSuccess}
      runMutation={cloneTaskRateSheet}
    >
      <ErrorRenderer
        render={(error) => (
          <TaskRateSheetForm
            errorMessage={error}
            loading={mutationLoading}
            oldSheetName={oldSheetName}
          />
        )}
      />
    </MutationForm>
  );
};

export default CloneTaskRateSheet;
